import { Logger } from '@sitecore-search/common';
import OrderCloudConfig from './OrderCloudConfig.js';
import SitecoreSearchConfig from './SitecoreSearchConfig.js';
const configBuilder = (config, setupOptions) => {
    if ('useToken' in setupOptions && typeof setupOptions.useToken !== 'undefined') {
        Logger.warn('Parameter "useToken" has been deprecated');
    }
    if (!setupOptions.customerKey) {
        // if customer key hasn't been provided, then we are working with OC
        return OrderCloudConfig.build(config, setupOptions);
    }
    return SitecoreSearchConfig.build(config, setupOptions);
};
export default configBuilder;
